import React from "react";
import classnames from "classnames";
import styles from "./Privacy.module.scss";

const DataDeletion: React.FC = () => (
    <div className={classnames("faq-container lp-container", styles.privacy)}>
        <h1 className="lph1">Data Deletion Policy</h1>
        <p>Send an email to hello@tacboard.com from the email address associated with your account requesting that all data be deleted. Your deletion request will be processed within 7 days.</p>
        <div style={{width:"100%",textAlign:"center",margin:"65px 0"}}>
            <p>* * * *</p>
        </div>
    </div>
)

export default DataDeletion;
